import { SelectionModel } from '@angular/cdk/collections';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from '@app/global services';
import {
  EVENT_ACAO_GERENCIAMENTO,
  IContentEventApi
} from '@app/global services/analytics-services';
import { IEtapa } from '@app/modules/etapas/models/etapas.model';
import { IMateriaPrima } from '@app/modules/materia-prima/models/materia-prima.model';
import {
  IPedidoParte,
  PedidoParteEtapa
} from '@app/modules/pedidos/model/pedidos-parte.model';
import {
  IPedidoImagem,
  IPedidos
} from '@app/modules/pedidos/model/pedidos.model';
import { PedidoParteService } from '@app/modules/pedidos/services/pedido-parte.service';
import { PedidoService } from '@app/modules/pedidos/services/pedido.service';
import { IProcessos } from '@app/modules/processos/models/processos.model';
import { IServicos } from '@app/modules/servicos/models/servicos.model';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { PdfViewerComponent } from '@app/shared/components/pdf-viewer/pdf-viewer.component';
import { Utils } from '@app/shared/helpers/utils';
import { DocumentoService } from '@app/shared/services';
import { Table } from 'primeng/table';
import { map } from 'rxjs/operators';
import {
  CHECBOX_HEADER_SELECTED_FLAG,
  ErroMessages,
  IErroMessages,
  ImagemService,
  PAGINATOR_SIZE_LOCALSTORAGE_KEY,
  TokenService,
  User,
  ViggoCoreDialogReorderColumns
} from 'viggo-sistemas-core-web';
import { BuildGerenciamentoColumns } from '../../utils/build_columns_gerenciamento';
import { DialogDetalhesPedidoComponent } from '../dialog-detalhes-pedido/dialog-detalhes-pedido.component';
import { DialogImgsPedidoComponent } from '../dialog-imgs-pedido/dialog-imgs-pedido.component';
import { DialogDataMonitoramento } from '../dialog-monitoramento/dialog-monitoramento.component';

export const KEY_DATA_SELECTION_PEDIDOS_PRODUCAO =
  'DATA_SELECTION_PEDIDOS_PRODUCAO';
export const KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO =
  'DATA_NOT_SELECTION_PEDIDOS_PRODUCAO';
export const KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO =
  'SELECTED_ALL_TABLE_PEDIDOS_PRODUCAO';
export const KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO =
  'KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO';
const KEY_SELECTED_COLUMNS = 'SELECTED_COLUMNS';
export const DEVICES_PHONE = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|Mac|AppleWebKit/i;
export const DEVICES_WEB = /Mozilla|Chrome|Safari|webOS/i;
@Component({
  selector: 'table-monitorados',
  templateUrl: './table-pedidos.component.html',
  styleUrls: ['./table-pedidos.component.scss'],
  providers: [DocumentoService, ImagemService]
})
export class TableMonitoradosComponent implements OnInit, OnChanges {
  @ViewChild('tablePedidos') tablePedido: Table;
  @Input() monitorados: IPedidos[];
  @Input() pageLength: number;
  @Input() page: number;
  @Input() totalPedidos: number;
  @Input() totalPartes: number;
  @Input() processos: number;
  @Input() quantidadePecas: number;
  @Input() quantidadeProdutos: number;
  @Input() filterByEtapa: boolean = false;
  @Input() filterByProcesso: boolean = false;
  @Input() showBtnActionsPartes: boolean = false;
  @Input() isTheLastProcess: boolean = false;
  @Input() isOnlyMonitoramento: boolean = false;
  @Input() loading = true;
  @Input() isEmpty = false;

  @Output() onHandlePage = new EventEmitter<any>();
  @Output() public readonly onReloadPage = new EventEmitter<void>();
  @Output() onShowData = new EventEmitter<any>();
  @Output() onGenerateError = new EventEmitter<any>();
  @Output() onGenerateFinalizarEtapa = new EventEmitter<IPedidoParte[]>();
  @Output() onGenerateFinalizarProcesso = new EventEmitter<IPedidos[]>();
  @Output() onGenerateConclusion = new EventEmitter<IPedidoParte[]>();
  @Output() onStartParte = new EventEmitter<IPedidoParte[]>();
  @Output() onStartPedido = new EventEmitter<IPedidos[]>();
  @Output() onSendPedido = new EventEmitter<IPedidos[]>();
  @Output() onSendPedidoConcluido = new EventEmitter<IPedidos[]>();
  @Output() onEnviarParaEtapa = new EventEmitter<IPedidoParte[]>();
  @Output() onEnviarParaEtapaAnterior = new EventEmitter<IPedidoParte>();
  @Output() updateActionConcluded = new EventEmitter<boolean>();

  @Input() showErrorMessage = false;
  @Input() errorTitle = 'ACESSO NEGADO';
  @Input() errorMessage = 'ACESSO NEGADO';
  @Input() errorImgSrc = './assets/images/access_denied.svg';
  @Input() public first = 0;
  @Input() public rows = 0;
  @Input() linha_producao_id: string;
  @Input() etapa: IEtapa;
  @Input() processo: IProcessos;
  @Input() menu: string;
  @Input() moduleName: string;
  @Input() moduleNameExpanded: string;

  dataSelectionPedidos: any[] = [];
  dataNotSelectionPedidos: any[] = [];
  dataSelectionPartes: any[] = [];
  selection = new SelectionModel<IPedidoParte>(true, []);
  cols: any[];
  selectedColumns: any[];
  columns = [];

  colsExpanded: any[];
  selectedColumnsExpanded: any[];
  columnsExpanded = [];
  isWeb = true;

  public paginatorPageSize: number;
  pageSizeOptions = [5, 10, 20, 50];

  @Input() statusParte: string;
  @Input() statusProcesso: string;
  @Input() statusPedido: string;
  @Input() actionConcluded: boolean;
  pedido_id: string;
  entitiesExpandedData: IPedidoParte[] = [];
  loadingExpandedData = false;
  isEmptyExpandedData = false;
  showErrorMessageExpandedData = false;
  errorTitleExpandedData = 'ACESSO NEGADO';
  errorMessageExpandedData = 'ACESSO NEGADO';
  errorImgSrcExpandedData = './assets/images/access_denied.svg';

  isUserAdmin: boolean;
  validActionsPedidos = {
    iniciar_producao_etapas: false,
    iniciar_producao_processo: false,
    processo_seguinte: false,
    processo_erro: false,
    processo_finalizar: false,
    enviar_multiplas_pecas: false,
    finalizar_multiplas_pecas: false,
    concluir_multiplas_pecas: false,
    concluir_pedido: false
  };
  validActionsPartes = {
    iniciar_producao: false,
    etapa_seguinte: false,
    etapa_erro: false,
    etapa_finalizar: false,
    concluir_peca: false,
    etapa_anterior: false
  };

  constructor(
    protected tokenService: TokenService,
    protected entityService: PedidoService,
    protected pedidoParteService: PedidoParteService,
    protected documentoService: DocumentoService,
    protected imagemService: ImagemService,
    protected router: Router,
    protected actRoute: ActivatedRoute,
    public matSnackBar: MatSnackBar,
    public dialog: MatDialog,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private breakpointObserver: BreakpointObserver,
    protected analyticsService: AnalyticsService
  ) {
    this.isUserAdmin =
      this.tokenService
        .getUser()
        .roles.find(it => it.name.toLocaleLowerCase() === 'admin') !==
      undefined;
  }

  /**
   * Resolução m10 (1280 x 800)
   * dispositivo: Mozilla/5.0 (Linux; Android 10; K) AppleWebKit/537.36 (KHTML, like Gecko) Chrome;119.0.0.0 Safari/573.36
   * breakpoint: (min-width: 960px) and (max-width: 1279.98px)
   */
  observerScreenBreakpoint() {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Web,
        Breakpoints.Large,
        Breakpoints.XLarge
      ])
      .subscribe(value => {
        if (
          DEVICES_PHONE.test(navigator.userAgent) ||
          DEVICES_WEB.test(navigator.userAgent)
        ) {
          const buildGerenciamentoColumns = new BuildGerenciamentoColumns(
            this.isTheLastProcess,
            this.onSendPedidoConcluido,
            this.onSendPedido,
            this.datePipe,
            this.showBtnActionsPartes,
            this.tokenService,
            this.moduleName,
            this.moduleNameExpanded
          );
          if (
            DEVICES_PHONE.test(navigator.userAgent) &&
            value.breakpoints['(max-width: 599.98px)']
          ) {
            this.isWeb = false;
            this.columns = buildGerenciamentoColumns.buildColumnsMobile();
            this.columnsExpanded = buildGerenciamentoColumns.buildColumnsExpandedMobile();
          } else if (
            DEVICES_PHONE.test(navigator.userAgent) &&
            value.breakpoints['(min-width: 600px) and (max-width: 959.98px)']
          ) {
            this.isWeb = false;
            this.columns = buildGerenciamentoColumns.buildColumnsMobile();
            this.columnsExpanded = buildGerenciamentoColumns.buildColumnsExpandedMobile();
          } else if (
            DEVICES_PHONE.test(navigator.userAgent) &&
            (value.breakpoints[
              '(min-width: 960px) and (max-width: 1279.98px)'
            ] ||
              value.breakpoints[
                '(min-width: 960px) and (max-width: 1279.98px)  and (orientation: landscape)'
              ])
          ) {
            this.isWeb = false;
            this.columns = buildGerenciamentoColumns.buildColumnsMobile();
            this.columnsExpanded = buildGerenciamentoColumns.buildColumnsExpandedMobile();
          } else if (
            DEVICES_PHONE.test(navigator.userAgent) &&
            value.breakpoints[
              '(min-width: 1280px) and (orientation: landscape)'
            ] &&
            !value.breakpoints['(min-width: 1920px)']
          ) {
            this.isWeb = false;
            this.columns = buildGerenciamentoColumns.buildColumnsMobile();
            this.columnsExpanded = buildGerenciamentoColumns.buildColumnsExpandedMobile();
          } else {
            this.isWeb = true;
            this.columns = buildGerenciamentoColumns.buildColumnsDefault();
            this.columnsExpanded = buildGerenciamentoColumns.buildColumnsExpandedDefault();
          }
          this.cols = this.columns;
          this.colsExpanded = this.columnsExpanded;
          this.fillInfoCols();
          this.fillInfoExpandedCols();
          buildGerenciamentoColumns.refreshColumnsUser(
            this.cols.map(it =>
              Utils.onlyAttributes(it, ['field', 'active', 'removable'])
            ),
            this.colsExpanded.map(it =>
              Utils.onlyAttributes(it, ['field', 'active', 'removable'])
            )
          );
        }
      });
  }

  /**
   * Exibe os adicionais presentes naquele pedido
   * @param adicionais
   */
  showAdicionais(adicionais: IMateriaPrima[]) {
    const showThem = {
      data: adicionais,
      cols: [
        {
          header: 'Código',
          field: 'materia_prima_codigo'
        },
        {
          header: 'Descrição',
          field: 'materia_prima_descricao'
        },
        {
          header: 'Categoria de Matéria Prima',
          field: 'categoria_descricao'
        }
      ],
      title: 'Lista de adicionais',
      subtitle: 'Total de ' + adicionais.length + ' adicionais'
    } as DialogDataMonitoramento;
    this.onShowData.emit(showThem);
  }

  /**
   * Exibe os serviços presentes naquele pedido
   * @param servicos
   */
  showServicos(servicos: IServicos[]) {
    const { currencyPipe } = this;
    const showThem = {
      data: servicos,
      cols: this.isUserAdmin
        ? [
            {
              header: 'Descrição',
              field: 'servico_descricao'
            },
            {
              header: 'Valor',
              field: 'valor',
              cellRenderer(rowValue) {
                return currencyPipe.transform(rowValue.valor, 'BRL');
              }
            },
            {
              header: 'Categoria',
              field: 'categoria_descricao'
            },
            {
              header: '',
              field: 'observacao'
            }
          ]
        : [
            {
              header: 'Descrição',
              field: 'servico_descricao'
            },
            {
              header: 'Categoria',
              field: 'categoria_descricao'
            }
          ],
      title: 'Lista de serviços',
      subtitle: 'Total de ' + servicos.length + ' serviços'
    } as DialogDataMonitoramento;
    this.onShowData.emit(showThem);
  }

  /**
   * Verifica as mudanças e altera o data
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.tokenService.isLoggedIn()) {
      // TODO: TA PEGANDO INFORMAÇÕES DE PARTES EM PEDIDOS DIFERENTES E VALIDANDO AS AÇÕES
      if (this && this.monitorados && changes) {
        this.observerScreenBreakpoint();
        if (
          ((changes.linha_producao_id &&
            changes.linha_producao_id.currentValue !== undefined &&
            changes.linha_producao_id.currentValue !==
              changes.linha_producao_id.previousValue) ||
            (changes.etapa &&
              changes.etapa.currentValue !== undefined &&
              changes.etapa.currentValue !== changes.etapa.previousValue)) &&
          this.tablePedido
        ) {
          this.tablePedido.expandedRowKeys = {};
          this.clearSelectionsValues();
          this.buildValidationActions();
        }
        if (changes.processo && changes.processo.currentValue !== undefined) {
          if (
            changes.processo.currentValue &&
            (!changes.processo.currentValue.gerencia_partes ||
              changes.processo.currentValue !==
                changes.processo.previousValue) &&
            this.tablePedido
          ) {
            this.tablePedido.expandedRowKeys = {};
            this.clearSelectionsValues();
          }
          this.buildValidationActions();
        }
        if (
          changes.statusParte &&
          changes.statusParte.previousValue !==
            changes.statusParte.currentValue &&
          !changes.loading &&
          changes.monitorados &&
          this.checkIsRowExpanded(changes.monitorados.currentValue)
        ) {
          this.expandedAction();
        } else if (
          changes.loading &&
          changes.loading.previousValue !== changes.loading.currentValue &&
          changes.monitorados &&
          this.checkIsRowExpanded(changes.monitorados.currentValue)
        ) {
          this.expandedAction();
        } else if (
          (changes.actionConcluded &&
            changes.actionConcluded.previousValue !==
              changes.actionConcluded.currentValue) ||
          (changes.monitorados &&
            this.checkIsRowExpanded(changes.monitorados.currentValue))
        ) {
          this.clearSelectionsValues();
          this.dataSelectionPartes = [];
          this.actionConcluded = false;
          this.updateActionConcluded.emit(false);
          this.expandedAction();
        } else if (changes.monitorados) {
          this.monitorados = this.checkAndMarkIfIsSelected(
            changes.monitorados.currentValue
          );
          const headerCheckboxAction =
            localStorage.getItem(
              KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO
            ) === 'true';
          const allFlag =
            localStorage.getItem(KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO) ===
            CHECBOX_HEADER_SELECTED_FLAG.ALL;
          const unSelectedEntities = JSON.parse(
            localStorage.getItem(KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO)
          );
          if (allFlag || headerCheckboxAction) {
            const idsUnSelecteds = new Set(
              unSelectedEntities.map(item => item.id)
            );
            this.selectEntities(
              changes.monitorados.currentValue.filter(
                it => !idsUnSelecteds.has(it.id)
              )
            );
            this.dataSelectionPedidos = JSON.parse(
              localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
            );
          }
          if (this.checkIsRowExpanded(changes.monitorados.currentValue))
            this.expandedAction();
        }
        // if (
        //   !(
        //     changes.filter &&
        //     changes.filter.previousValue !== changes.filter.currentValue
        //   )
        // ) {
        //   this.selection.clear();
        //   this.dataSelectionPartes = [];
        // }
      }
    }
  }

  ngOnInit() {
    this.paginatorPageSize =
      +localStorage.getItem(PAGINATOR_SIZE_LOCALSTORAGE_KEY) || 5;

    localStorage.setItem(
      KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
      JSON.stringify(this.dataSelectionPedidos)
    );
    localStorage.setItem(
      KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO,
      JSON.stringify(this.dataNotSelectionPedidos)
    );
    localStorage.setItem(
      KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO,
      CHECBOX_HEADER_SELECTED_FLAG.EMPTY
    );
    localStorage.setItem(
      KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO,
      this.headerChecked.toString()
    );
  }

  fillInfoCols() {
    const lsSelectedColumns = JSON.parse(
      localStorage.getItem(`${KEY_SELECTED_COLUMNS}_${this.moduleName}`)
    );
    const { settings } = this.tokenService.getUser() as User;
    const index = (settings['colunas'] as any[]).findIndex(
      col => col.module === this.moduleName
    );
    if (index >= 0) {
      const columnsUser = settings['colunas'][index].colunas;
      const columns = columnsUser
        .filter(col => this.cols.some(col2 => col.field === col2.field))
        .map(it => {
          const index2 = this.cols.findIndex(it2 => it.field === it2.field);
          return {
            ...this.cols[index2],
            active: it.active,
            removable: it.removable
          };
        });
      this.selectedColumns = columns;
      this.columns = columns.filter(it => it.active);
    } else if (index === -1 && lsSelectedColumns) {
      this.selectedColumns = lsSelectedColumns;
      this.columns = lsSelectedColumns.filter(it => it.active);
    } else {
      this.selectedColumns = this.cols;
      this.columns = this.cols.filter(it => it.active);
    }
  }

  fillInfoExpandedCols() {
    const lsSelectedColumns = JSON.parse(
      localStorage.getItem(`${KEY_SELECTED_COLUMNS}_${this.moduleNameExpanded}`)
    );
    const { settings } = this.tokenService.getUser() as User;
    const index = (settings['colunas'] as any[]).findIndex(
      col => col.module === this.moduleNameExpanded
    );
    if (index >= 0) {
      const columnsUser = settings['colunas'][index].colunas;
      const columns = columnsUser
        .filter(col => this.colsExpanded.some(col2 => col.field === col2.field))
        .map(it => {
          const index2 = this.colsExpanded.findIndex(
            it2 => it.field === it2.field
          );
          return {
            ...this.colsExpanded[index2],
            active: it.active,
            removable: it.removable
          };
        });
      this.selectedColumnsExpanded = columns;
      this.columnsExpanded = columns.filter(it => it.active);
    } else if (index === -1 && lsSelectedColumns) {
      this.selectedColumnsExpanded = lsSelectedColumns;
      this.columnsExpanded = lsSelectedColumns.filter(it => it.active);
    } else {
      this.selectedColumnsExpanded = this.colsExpanded;
      this.columnsExpanded = this.colsExpanded.filter(it => it.active);
    }
  }

  /**
   * Monitora a ação de expanded da tabela, mas também é acionada quando detectar uma mudança de loading ou statusParte
   * @param element
   */
  expandedAction(element?) {
    if (element && element.data) {
      this.pedido_id = element.data.id;
    }
    if (this.pedido_id) {
      this.loadingExpandedData = true;
      var url = `pedido_id=${this.pedido_id}&include=etapa&order_by=peca.descricao asc,numero asc&status=${this.statusParte}`;
      if (!this.isOnlyMonitoramento) url += `&filtra_partes=true`;
      if (this.filterByEtapa && this.etapa) url += `&etapa_id=${this.etapa.id}`;
      if (this.filterByProcesso && this.processo)
        url += `&processo_id=${this.processo.id}`;
      this.pedidoParteService
        .getEntitiesByParams(url, this.tokenService.getDomain().id, true)
        .subscribe(
          entities => {
            const idx = (JSON.parse(
              localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
            ) as any[]).findIndex(it => it.id === this.pedido_id);
            if (idx >= 0) this.unSelectRow(element);
            this.entitiesExpandedData = entities.data;
            if (
              JSON.stringify(entities.data) !==
              JSON.stringify(this.dataSelectionPartes)
            )
              this.dataSelectionPartes = [];
            // this.page = entities.pagination.page;
            // this.pageLength = entities.pagination.total;
          },
          (err: HttpErrorResponse) => {
            this.errorTitleExpandedData = 'Erro detectado';
            this.errorMessageExpandedData = err.message;
            this.displayError(err, true);
          },
          () => {
            this.loadingExpandedData = false;
            this.entitiesExpandedData.length === 0
              ? (this.isEmptyExpandedData = true)
              : (this.isEmptyExpandedData = false);
          }
        );
    }
  }

  /**
   * Exibe as imagens do pedido
   * @param imagens
   */
  openDialogImgs(imagens: IPedidoImagem[]) {
    for (let index = 0; index < 3; index += 1) {
      const element = imagens[index];
      if (element && element.imagem_id)
        this.imagemService
          .donwloadImagem({ imagemId: element.imagem_id, quality: 'max' })
          .pipe(map(base64 => ({ ...element, imagem_arquivo: base64 })))
          .subscribe(
            imagem => {
              imagens[index] = { ...imagem };
            },
            (err: HttpErrorResponse) => this.displayError(err)
          );
    }
    this.dialog.open(DialogImgsPedidoComponent, {
      data: { imagens: imagens },
      width: '500px',
      height: '500px',
      panelClass: ['dialog-sem-padding', 'custom-container']
    });
  }

  /**
   * Download do PDF da ficha tecnica
   */
  public downloadFicha(ficha_tecnica_id: string) {
    this.analyticsService.trackEventUseApi(EVENT_ACAO_GERENCIAMENTO, {
      conteudo: JSON.stringify({ ficha_tecnica_id }),
      origem: `VISUALIZAR FICHA TÉCNICA - ${this.router.url}`
    } as IContentEventApi);
    this.documentoService.downloadDocumento(ficha_tecnica_id).subscribe(
      doc => {
        const blob = new Blob([doc], {
          type: 'application/pdf'
        });
        const file = new File([blob], 'ficha_tecnica', { type: blob.type });
        this.analyticsService.trackEventUseApi(EVENT_ACAO_GERENCIAMENTO, {
          conteudo: JSON.stringify({ ficha_tecnica_id }),
          origem: `VISUALIZAR FICHA TÉCNICA - ${this.router.url}`,
          rota: 'GET - /documentos',
          resposta_api: '200 - Ok'
        } as IContentEventApi);
        this.dialog.open(PdfViewerComponent, {
          data: {
            file
          },
          position: {
            top: '0px'
          },
          panelClass: ['dialog-sem-padding']
        });
      },
      (err: HttpErrorResponse) => {
        this.analyticsService.trackEventUseApi(EVENT_ACAO_GERENCIAMENTO, {
          conteudo: JSON.stringify({ ficha_tecnica_id }),
          origem: `VISUALIZAR FICHA TÉCNICA - ${this.router.url}`,
          rota: 'GET - /documentos',
          resposta_api: `${err.status.toString()} - ${err.statusText}: ${
            err.error
          }`
        } as IContentEventApi);
        this.displayError(err);
      }
    );
  }

  /**
   * Abre o dialog que expõe os detalhes do pedido
   * @param pedido
   */
  public openDetalhesPedido(pedido: IPedidos) {
    this.dialog.open(DialogDetalhesPedidoComponent, {
      data: { pedido: pedido },
      position: {
        top: '0px'
      },
      panelClass: ['dialog-sem-padding', 'custom-container']
    });
  }

  /**
   * Abre o dialog de ordenação e remoção de colunas e salva no LS ao final
   * para garantir a seleção do usuário
   */
  openDialogReorderColumns(expanded?: boolean) {
    var config = {
      data: {
        selectedColumns: expanded
          ? this.selectedColumnsExpanded
          : this.selectedColumns,
        defaultColumns: expanded ? this.colsExpanded : this.cols,
        menu: this.menu,
        module_name: expanded ? this.moduleNameExpanded : this.moduleName
      } as any,
      panelClass: ['custom-container-surface-visible'],
      disableClose: true
    } as MatDialogConfig;
    if (!this.isWeb) {
      config = {
        ...config,
        height: 'calc(100% - 15%)',
        width: 'calc(100% - 30px)',
        maxWidth: '100%',
        maxHeight: '100%'
      } as MatDialogConfig;
    }
    this.dialog
      .open(ViggoCoreDialogReorderColumns, config)
      .afterClosed()
      .subscribe(res => {
        if (res && res.confirm) {
          if (expanded) {
            this.selectedColumnsExpanded = res.selectedColumns;
            this.columnsExpanded = res.selectedColumns.filter(it => it.active);
          } else {
            this.selectedColumns = res.selectedColumns;
            this.columns = res.selectedColumns.filter(it => it.active);
          }
        }
      });
  }

  handlePage(event): void {
    localStorage.setItem(PAGINATOR_SIZE_LOCALSTORAGE_KEY, `${event.rows}`);
    this.first = event.first;
    this.rows = event.rows;
    this.onHandlePage.emit(event);
  }

  checkDataSelectionFinalizados(pedido_id: string) {
    if (this.dataSelectionPartes.length === 0) return true;
    else if (this.dataSelectionPartes[0].pedido_id === pedido_id)
      return (
        this.dataSelectionPartes.some(
          it =>
            !it.is_etapa_iniciada ||
            !it.is_etapa_finalizada ||
            it.status === 'CONCLUIDO'
        ) ||
        this.statusParte !== 'FINALIZADO' ||
        this.statusPedido !== 'EM_ANDAMENTO' ||
        this.statusProcesso !== 'EM_ANDAMENTO' ||
        !this.etapa
      );
    else return true;
  }

  checkDataSelectionParaFinalizar(pedido_id: string) {
    if (this.dataSelectionPartes.length === 0) return true;
    else if (this.dataSelectionPartes[0].pedido_id === pedido_id)
      return (
        this.dataSelectionPartes.some(
          it =>
            !it.is_etapa_iniciada ||
            it.is_etapa_finalizada ||
            it.has_erro_pendente ||
            it.etapas.length === 0
        ) ||
        this.statusParte !== 'PRODUZINDO' ||
        this.statusPedido !== 'EM_ANDAMENTO' ||
        this.statusProcesso !== 'EM_ANDAMENTO' ||
        !this.etapa
      );
    else return true;
  }

  checkDataSelectionParaIniciar(pedido_id: string) {
    if (this.dataSelectionPartes.length === 0) return true;
    else if (this.dataSelectionPartes[0].pedido_id === pedido_id)
      return (
        this.dataSelectionPartes.some(it => it.is_etapa_iniciada) ||
        this.statusParte !== 'AGUARDANDO' ||
        !this.etapa
      );
    else return true;
  }

  checkDataSelectionParaIniciarProcesso() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return (
        this.dataSelectionPedidos.some(it => it.is_processo_iniciado) ||
        this.statusProcesso !== 'AGUARDANDO'
      );
    }
  }

  checkDataSelectionParaIniciarPecas() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return this.statusParte !== 'AGUARDANDO' || !this.etapa;
    }
  }

  checkDataSelectionParaFinalizarProcesso() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return (
        this.dataSelectionPedidos.some(
          it =>
            !it.is_processo_iniciado ||
            it.is_processo_finalizado ||
            it.has_erro_pendente ||
            it.processos.length === 0
        ) ||
        this.statusProcesso !== 'EM_ANDAMENTO' ||
        this.statusPedido !== 'CONCLUIDO_PARTES'
      );
    }
  }

  checkDataSelectionParaFinalizarPecas() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return (
        this.dataSelectionPedidos.some(it => !it.is_processo_iniciado) ||
        this.statusParte !== 'PRODUZINDO' ||
        this.statusPedido !== 'EM_ANDAMENTO' ||
        this.statusProcesso !== 'EM_ANDAMENTO' ||
        !this.etapa
      );
    }
  }

  checkDataSelectionParaConcluirPedidos() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return (
        this.dataSelectionPedidos.some(
          it =>
            !it.is_processo_iniciado ||
            !it.is_processo_finalizado ||
            it.status !== 'CONCLUIDO_PARTES'
        ) ||
        this.statusProcesso !== 'FINALIZADO' ||
        this.statusPedido !== 'CONCLUIDO_PARTES'
      );
    }
  }

  checkDataSelectionParaConcluirPecas() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return (
        this.dataSelectionPedidos.some(it => !it.is_processo_iniciado) ||
        this.statusParte !== 'FINALIZADO' ||
        this.statusPedido !== 'EM_ANDAMENTO' ||
        this.statusProcesso !== 'EM_ANDAMENTO' ||
        !this.etapa
      );
    }
  }

  checkDataSelectionParaEncaminharProcesso() {
    if (this.dataSelectionPedidos.length === 0) return true;
    else {
      return (
        this.dataSelectionPedidos.some(
          it =>
            !it.is_processo_iniciado ||
            !it.is_processo_finalizado ||
            it.status !== 'CONCLUIDO_PARTES'
        ) ||
        this.statusProcesso !== 'FINALIZADO' ||
        this.statusPedido !== 'CONCLUIDO_PARTES'
      );
    }
  }

  checkEtapasVoltadas(etapas: PedidoParteEtapa[]) {
    return etapas.filter(it => !it.voltada).length < 2;
  }

  onRowSelect(event) {
    this.dataSelectionPartes = this.dataSelectionPartes.filter(
      it => it.length !== 0
    );
  }

  onSendStartEtapa() {
    this.onStartParte.emit(this.dataSelectionPartes);
    this.dataSelectionPartes = [];
  }

  onSendEtapa() {
    this.onEnviarParaEtapa.emit(this.dataSelectionPartes);
    this.dataSelectionPartes = [];
  }

  onFinalizarEtapa() {
    this.onGenerateFinalizarEtapa.emit(this.dataSelectionPartes);
    this.dataSelectionPartes = [];
  }

  onConclusion() {
    this.onGenerateConclusion.emit(this.dataSelectionPartes);
    this.dataSelectionPartes = [];
  }

  /**
   * Monta os objetos de validação para os actions de pedidos e pedido_partes
   */
  buildValidationActions() {
    this.validActionsPedidos = {
      iniciar_producao_processo: this.validAction(
        'PUT',
        '/pedidos/inicia_processo'
      ),
      iniciar_producao_etapas: this.validAction(
        'PUT',
        '/pedido_partes/iniciar_etapas'
      ),
      processo_seguinte: this.validAction('PUT', '/pedidos/reg_processo'),
      processo_erro:
        (this.validAction('POST', '/erro_processos') ||
          this.validAction('PUT', '/erro_processos/<id>/corrigir')) &&
        this.processo &&
        !this.processo.gerencia_partes,
      processo_finalizar: this.validAction('PUT', '/pedidos/finaliza_processo'),
      enviar_multiplas_pecas: this.validAction(
        'PUT',
        '/pedido_partes/reg_etapa_multiplas'
      ),
      finalizar_multiplas_pecas: this.validAction(
        'PUT',
        '/pedido_partes/finaliza_etapas'
      ),
      concluir_multiplas_pecas: this.validAction(
        'PUT',
        '/pedido_partes/concluir_etapas'
      ),
      concluir_pedido: this.validAction('PUT', '/pedidos/reg_evento')
    };
    this.validActionsPartes = {
      iniciar_producao: this.validAction(
        'PUT',
        '/pedido_partes/iniciar_etapas'
      ),
      etapa_seguinte: this.validAction('PUT', '/pedido_partes/<id>/reg_etapa'),
      etapa_erro:
        this.validAction('POST', '/erros') ||
        this.validAction('PUT', '/erros/<id>/corrigir'),
      etapa_finalizar: this.validAction(
        'PUT',
        '/pedido_partes/finaliza_etapas'
      ),
      concluir_peca: this.validAction('PUT', '/pedido_partes/concluir_etapas'),
      etapa_anterior: this.validAction(
        'PUT',
        '/pedido_partes/<id>/voltar_etapa'
      )
    };
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validAction(action: string, url_name: string): any {
    const routes = this.tokenService.getRoutes();
    if (routes && routes.length > 0 && url_name) {
      const routesAuthorization = routes.filter(r =>
        new RegExp(`^${url_name}`).test(r.url)
      );
      if (routesAuthorization && routesAuthorization.length > 0) {
        const url_return = routesAuthorization.find(
          route => route.url === url_name && route.method === action
        );
        return url_return !== undefined && url_return !== null;
      } else return false;
    } else return false;
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.dialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: err.error,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.checkError();
  }

  // LÓGICA DE SELEÇÃO DOS PEDIDOS

  headerChecked = false;

  /**
   * Captura as tuplas da tabela que foram selecionadas e são salvas no LS
   * @param event
   */
  selectEntities(event) {
    if (
      event.length !== 0 &&
      this.tablePedido &&
      this.tablePedido.value.length !== 0
    ) {
      this.markEntitySelected(event);
    } else if (event.length !== 0) {
      this.markEntitySelected(event);
    }
  }

  markEntitySelected(event) {
    let itens = [];
    const selectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
    );
    const unSelectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO)
    );
    if (selectedEntities && selectedEntities.length !== 0)
      itens = selectedEntities;

    event.forEach(select => {
      const index = selectedEntities.findIndex(it => it.id === select.id);
      if (index >= 0) return;
      else {
        select.isSelected = !select.isSelected;
        itens.push(select);
      }
    });
    localStorage.setItem(
      KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
      JSON.stringify(itens)
    );

    if (unSelectedEntities && unSelectedEntities.length !== 0) {
      itens.forEach(it => {
        const index = unSelectedEntities.findIndex(it2 => it.id === it2.id);
        if (index >= 0) {
          unSelectedEntities.splice(index, 1);
          localStorage.setItem(
            KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO,
            JSON.stringify(unSelectedEntities)
          );
        }
      });
    }
    localStorage.setItem(
      KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO,
      itens.length === this.pageLength
        ? CHECBOX_HEADER_SELECTED_FLAG.ALL
        : this.headerChecked && unSelectedEntities.length === 0
        ? CHECBOX_HEADER_SELECTED_FLAG.ALL
        : CHECBOX_HEADER_SELECTED_FLAG.PARTIAL
    );
  }

  /**
   * Checa se a tupla que foi removida da seleção estava no LS e atualiza a info
   * no LS
   * @param event
   */
  unSelectRow(event) {
    const selectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
    );
    const unSelectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO)
    );
    const headerChexbox =
      localStorage.getItem(KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO) ===
      CHECBOX_HEADER_SELECTED_FLAG.ALL;
    if (selectedEntities && selectedEntities.length !== 0) {
      const index = selectedEntities.findIndex(it => it.id === event.data.id);
      if (index >= 0) {
        event.data.isSelected = !event.data.isSelected;
        selectedEntities.splice(index, 1);
        localStorage.setItem(
          KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
          JSON.stringify(selectedEntities)
        );
        unSelectedEntities.push(event.data);
        localStorage.setItem(
          KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO,
          JSON.stringify(unSelectedEntities)
        );
        this.dataSelectionPedidos = selectedEntities;
        this.dataNotSelectionPedidos = unSelectedEntities;
        if (headerChexbox) {
          if (selectedEntities.length === 0) {
            localStorage.setItem(
              KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO,
              CHECBOX_HEADER_SELECTED_FLAG.EMPTY
            );
            this.headerChecked = false;
            localStorage.setItem(
              KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO,
              this.headerChecked.toString()
            );
          } else {
            localStorage.setItem(
              KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO,
              CHECBOX_HEADER_SELECTED_FLAG.PARTIAL
            );
          }
        }
      }
    }
  }

  /**
   * Registra o evento de marcar ALL - PARTIAL - EMPTY do headerCheckbox
   * @param event
   */
  headerChecboxAction(event) {
    this.headerChecked = event.checked;
    localStorage.setItem(
      KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO,
      this.headerChecked.toString()
    );
    localStorage.setItem(
      KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO,
      event.checked
        ? CHECBOX_HEADER_SELECTED_FLAG.ALL
        : CHECBOX_HEADER_SELECTED_FLAG.EMPTY
    );
    localStorage.setItem(
      KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO,
      JSON.stringify([])
    );

    if (!event.checked) {
      this.dataSelectionPedidos = [];
      this.dataNotSelectionPedidos = [];
      localStorage.setItem(
        KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
        JSON.stringify([])
      );
      localStorage.setItem(
        KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO,
        JSON.stringify([])
      );
    } else {
      let itens = [];

      const selectedEntities = JSON.parse(
        localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
      );
      if (event.checked) {
        if (selectedEntities && selectedEntities.length !== 0) {
          itens = selectedEntities;

          this.monitorados.forEach((select: any) => {
            const index = selectedEntities.findIndex(it => it.id === select.id);
            if (index >= 0) return;
            else {
              select.isSelected = !select.isSelected;
              itens.push(select);
            }
          });

          this.dataSelectionPedidos = itens;
          localStorage.setItem(
            KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
            JSON.stringify(itens)
          );
        } else {
          this.monitorados.forEach((select: any) => {
            select.isSelected = !select.isSelected;
            itens.push(select);
          });
          this.dataSelectionPedidos = itens;
          localStorage.setItem(
            KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
            JSON.stringify(itens)
          );
        }
      } else if (selectedEntities && selectedEntities.length !== 0) {
        itens = selectedEntities;

        this.monitorados.forEach((select: any) => {
          const index = selectedEntities.findIndex(it => it.id === select.id);
          if (index >= 0) itens.splice(index, 1);
          else {
            select.isSelected = !select.isSelected;
            itens.push(select);
          }
        });

        this.dataSelectionPedidos = itens;
        localStorage.setItem(
          KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
          JSON.stringify(itens)
        );
      }
    }
  }

  /**
   * Pedidos selecionadas
   */
  get selectedEntities(): any[] {
    const selectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
    );
    if (selectedEntities && selectedEntities.length !== 0)
      return selectedEntities;
    return this.dataSelectionPedidos;
  }

  /**
   * Pedidos selecionadas
   */
  get unSelectedEntities(): any[] {
    const unSelectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO)
    );
    if (unSelectedEntities && unSelectedEntities.length !== 0)
      return unSelectedEntities;
    return this.dataNotSelectionPedidos;
  }

  /**
   * Identifica se a flag de ALL está marcada para headercheckbox
   */
  get isCheckAllActivate(): boolean {
    return (
      localStorage.getItem(KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO) ===
      CHECBOX_HEADER_SELECTED_FLAG.ALL
    );
  }

  /**
   * Identifica se a flag de PARTIAL está marcada para headercheckbox
   */
  get isPartial(): boolean {
    return (
      localStorage.getItem(KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO) ===
      CHECBOX_HEADER_SELECTED_FLAG.PARTIAL
    );
  }

  /**
   * Limpa as variações e LS que identificam as seleções do usuário
   */
  clearSelectionsValues() {
    this.monitorados = this.monitorados.map(it => {
      return {
        ...it,
        isSelected: false
      };
    });
    this.dataSelectionPedidos = [];
    this.dataNotSelectionPedidos = [];
    this.headerChecked = false;
    localStorage.setItem(
      KEY_DATA_SELECTION_PEDIDOS_PRODUCAO,
      JSON.stringify(this.dataSelectionPedidos)
    );
    localStorage.setItem(
      KEY_DATA_NOT_SELECTION_PEDIDOS_PRODUCAO,
      JSON.stringify(this.dataNotSelectionPedidos)
    );
    localStorage.setItem(
      KEY_DATA_ALL_SELECTED_PEDIDOS_PRODUCAO,
      CHECBOX_HEADER_SELECTED_FLAG.EMPTY
    );
    localStorage.setItem(
      KEY_HEADERCHECKBOX_CHECKED_PEDIDOS_PRODUCAO,
      this.headerChecked.toString()
    );
  }

  /**
   * Checa se dentre as entidades selecionadas há alguma retornada no GET
   * para preencher o isSelected e ativar as validações pendentes em cada tupla
   * @param entities
   * @returns
   */
  checkAndMarkIfIsSelected(entities: any[]) {
    const selectedEntities = JSON.parse(
      localStorage.getItem(KEY_DATA_SELECTION_PEDIDOS_PRODUCAO)
    ) as any[];
    if (
      this.tablePedido &&
      entities.length !== 0 &&
      selectedEntities.length !== 0
    ) {
      return entities.map(it => {
        const selectedIdx = selectedEntities.findIndex(it2 => it.id === it2.id);
        return {
          ...it,
          isSelected: selectedIdx >= 0
        };
      });
    }
    return entities;
  }

  /**
   * Checa se dentre as chaves expandidas da tabela está alguma entidade retornada
   * no GET para ai sim acionar a função de listar as partes
   * @param entities
   * @returns
   */
  checkIsRowExpanded(entities: any[]) {
    if (entities.length === 0) return false;
    if (this.tablePedido) {
      const k = Object.keys(this.tablePedido.expandedRowKeys).filter(
        it => it !== null && it !== undefined
      );
      return (
        entities.findIndex(it => {
          const kIdx = k.findIndex(it2 => it.numero === Number(it2));
          return kIdx >= 0;
        }) >= 0
      );
    }
  }
}
